import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import swal from "sweetalert2";
import { SalesPlan } from "../../../common/SalesPlan";
import * as fromRootStore from "../../../reducers";
import { FinyearService, SalesPlanService } from "../../../services/index";
declare var google;

@Component({
  selector: "plan-details",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./salesplanreport.component.html",
})
export class SalesPlanReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Input() _params: any;

  finyearCtrl: FormControl = new FormControl();
  finyear: any;
  agent: any;
  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    let invdata = Object.assign({}, val["data"]);
    // delete invdata['invdet'];
    this.planData = invdata;

    // this.invdata.invdt = new Date(('' + this.invdata.invdt).replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
  }

  get params(): any[] {
    return this._params;
  }

  isLoadMask: Promise<any>;
  finyearList: any[];
  loadingIndicator: boolean = true;
  mode: any;

  isLoading: boolean = false;
  viewMode = "LOAD";

  planData: any;

  data: any;

  constructor(
    public store: Store<fromRootStore.State>,
    private salesplanService: SalesPlanService,
    public toasterService: ToasterService,
    private finyearService: FinyearService
  ) {}

  ngOnInit(): void {
    this.data = {
      sp_id: 0,
      fin_id: 3,
      fin_year: "2018-2019",
      sales_target: 0,
      seasoncombo: [],
      order_per: 0,
      order_target: 0,
      seasons: [],
      agents: [],
      list: [],
      plan_details: [],
    };
    this.LoadFinYearList();
  }
  initData() {
    this.process();
  }
  viewPartyWise(data) {
    this.isLoading = true;
    data.party = _.reverse(_.sortBy(data.party, "order_target"));
    this.agent = data;
    this.refreshTotal(this.agent);
    this.viewMode = "PARTY";
    this.viewAdjust();
  }
  viewAgentWise() {
    this.isLoading = true;
    this.viewMode = "AGENT";
    this.refreshTotal(this.data);
    this.viewAdjust();
  }

  setTableColumnsWidth(viewType = "sptrans") {
    const b = document.querySelector("." + viewType + " .sp-cf");
    b["onscroll"] = function () {
      const h = document.querySelector("." + viewType + " .sp-ch"),
        f = document.querySelector("." + viewType + " .sp-cf"),
        b = document.querySelector("." + viewType + " .sp-cb");
      h.scrollLeft = f.scrollLeft;
      b.scrollLeft = f.scrollLeft;
    };
    let ht = document.querySelector("." + viewType + " #sp-header-tab");
    let width = ht["offsetWidth"] + 20;
    $("." + viewType + " .sp-body-div").css({ width: width + "px" });
  }

  viewAdjust() {
    let that = this;
    that.isLoading = true;
    setTimeout(function () {
      that.setTableColumnsWidth("spreport");
      that.isLoading = false;
    }, 200);
  }
  /* orderData(res) {
        let isAgent = (res.agents),
            list = (isAgent) ? res.agents : res.party;
        list = _.reverse(_.sortBy(list, 'order_target'));
        res.list = list;
        if (isAgent) {
            for (let i = 0; i < list.length; i++) {
                const li = list[i];
                list[i] = this.orderData(li);
            }
        }
        return res;
    } */

  loadData() {
    this.viewMode = "LOAD";
    let params = {
      fin_id: this.data.fin_id,
      finyear: this.data.finyear,
      sp_id: this.data.sp_id,
      sales_target: this.data.sales_target,
      order_per: this.data.order_per,
      order_target: this.data.order_target,
    };
    let that = this;
    this.isLoading = true;
    this.salesplanService.getSalesPlanDetails(params).then((res: any) => {
      this.isLoading = false;
      res.agents = _.reverse(_.sortBy(res.agents, "order_target"));

      that.data = res;
      that.process();

      that.viewMode = "AGENT";
      that.viewAdjust();
    });
  }

  moveIt(id: string, key: string, it) {
    if (id.search("spd-") > -1) {
      let inds = id.split("-"),
        xlen = (this.data["seasons"].length + 1) * 2,
        ylen = (this.data["agents"].length + 1) * 2,
        x = parseInt(inds[2]),
        y = parseInt(inds[1]);
      switch (key) {
        case "Down":
          y++;
          break;
        case "Up":
          y--;
          break;
        case "Right":
        case "Enter":
          x++;
          break;
        case "Left":
          x--;
          break;
        default:
          return;
      }
      if (x < 0) {
        x = xlen - 1;
      } else if (x >= xlen) {
        x = 0;
        y++;
      }
      if (y < 0) {
        y = ylen - 1;
      } else if (y >= ylen) {
        y = 0;
        x = 0;
      }
      let target = "#spd-" + y + "-" + x,
        el = $(target);
      if (el) {
        event.preventDefault();
        el.select();
        let offset = el.offset();
        $("#sp-scrollable").scrollTop(y * 30 - 50);
        $("#sp-scrollable").scrollLeft(offset.left);
      } else {
        console.log("#spd-" + y + "-" + x);
        if (it++ < 10) {
          this.moveIt(target, key, it);
        }
      }
    }
  }
  hotkeys(event) {
    let id = event.srcElement.id || "",
      key = event.keyIdentifier;
    /*if(key=='Enter'){
                this.onSaveSalesPlan();
            return;
        }*/
    this.moveIt(id, key, 0);
  }

  trackByIndex(index: number, value: number) {
    return index;
  }

  calcOT(q, p) {
    let r = 0;
    q = this.ifNaN(q);
    p = this.ifNaN(p);
    if (p > 0) {
      r = Math.round((q / p) * 100);
    } else {
      r = q;
    }
    return this.ifNaN(r);
  }

  findOT(data) {
    let st = data.sales_target,
      op = data.order_per;
    data.order_target = this.calcOT(st, op);
  }
  round(no) {
    no = isNaN(parseFloat(no)) ? 0 : parseFloat(no);
    return Math.round(no * 100) / 100;
  }
  calcSP(ot, ao) {
    return this.round((ot / ao) * 100);
  }
  findSP(data) {
    let ot = data.order_target,
      ao = data.actual_order;
    //
    data.sales_per = this.calcSP(ot, ao);
  }

  calc(row, s_id) {
    this.process();
  }
  ifNaN(no) {
    return isNaN(parseInt(no)) ? 0 : parseInt(no);
  }

  calcOP(ptype = "data") {
    this.applyOP(this.data, "data");
    this.process();
  }

  applyOP(data, ptype) {
    let seasons = data.seasons,
      op = data.order_per,
      agents = ptype == "data" ? data.agents : data.party;
    for (let i = 0; i < seasons.length; i++) {
      seasons[i].order_per = op;
    }

    for (let i = 0; i < agents.length; i++) {
      let agent = agents[i];
      agent.order_per = op;
      /*    if(ptype=='data') {
                    this.applyOP(agents[i],'agent');
                }*/
      for (let j = 0; j < agent.seasons.length; j++) {
        agent.seasons[j].order_per = op;
      }

      for (let j = 0; j < agent.party.length; j++) {
        let party = agent.party[j];
        party.order_per = op;
        for (let k = 0; k < party.seasons.length; k++) {
          party.seasons[k].order_per = op;
        }
      }
    }
  }

  calcOPSeason(s_id, type = "data") {
    let data = this[type],
      agents = data.agents ? data.agents : data.party,
      seasons = data.seasons,
      season = seasons[s_id],
      op = season.order_per;

    for (let i = 0; i < agents.length; i++) {
      agents[i].seasons[s_id].order_per = op;
    }

    this.process();
  }

  calcOPAgent(a_ind, type = "data") {
    let data = this[type],
      agents = data.agents ? data.agents : data.party,
      agent = agents[a_ind],
      seasons = agent.seasons,
      op = agent.order_per;

    for (let i = 0; i < seasons.length; i++) {
      seasons[i].order_per = op;
    }
    this.process();
  }

  calcOPASeason(s_id) {
    this.process();
  }

  calcOPPSeason(s_id) {
    this.process();
  }
  calcOPParty(a_ind) {
    this.process();
  }

  findTotalDiff(list, ST, OT) {
    for (let i = 0; i < list.length; i++) {
      const li = list[i],
        st = li.sales_target,
        ot = li.order_target;
      ST += this.ifNaN(st);
      OT += this.ifNaN(ot);
    }

    return {
      st: ST,
      ot: OT,
    };
  }

  refreshTotal(data) {
    let agents = data.agents ? data.agents : data.party,
      seasons = data.seasons;
    if (data.name == "DIRECT1") {
      //
    }
    // OT = (data.agents)?data.order_target : data.actual_order,
    let st = 0,
      ot = 0,
      ao = 0,
      sp = 0;
    //Season loop
    for (let i = 0; i < seasons.length; i++) {
      let s = seasons[i];
      st += this.ifNaN(s.sales_target);
      ot += this.ifNaN(s.order_target);
      ao += this.ifNaN(s.actual_order);
      sp += this.ifNaN(s.sales_per);

      let sst = 0,
        sot = 0,
        sao = 0,
        ssp = 0;
      for (let j = 0; j < agents.length; j++) {
        let as = agents[j].seasons[i];
        (sst += this.ifNaN(as.sales_target)),
          (sot += this.ifNaN(as.order_target));
        (ssp += this.ifNaN(as.sales_per)), (sao += this.ifNaN(as.actual_order));
      }
      //  s.sales_per = this.calcSP(OT,s.actual_order);
      // console.log(OT," ; ", s.actual_order, " : ",s.sales_per);
      s.sw_st = sst;
      s.sw_ot = sot;
      s.sw_sp = ssp;
      s.sw_ao = sao;
      s.swd_st = this.ifNaN(s.sales_target - sst);
      s.swd_ot = this.ifNaN(s.order_target - sot);
    }
    data.sw_st = st;
    data.sw_ot = ot;
    data.sw_ao = ao;
    data.sw_sp = sp;

    data.swd_st = this.ifNaN(data.sales_target - st);
    data.swd_ot = this.ifNaN(data.order_target - ot);
    data.swd_ao = this.ifNaN(data.actual_order - ao);
    // data.swd_sp = this.ifNaN(data.sales_per - sp);

    //Agent Loop
    (st = 0), (ot = 0), (sp = 0), (ao = 0);
    for (let i = 0; i < agents.length; i++) {
      let a = agents[i],
        sst = 0,
        sot = 0,
        ssp = 0,
        sao = 0;
      (st += a.sales_target), (ot += a.order_target), (sp += a.sales_per);
      for (let j = 0; j < seasons.length; j++) {
        let s = seasons[j];
        sst += this.ifNaN(a.seasons[j].sales_target);
        ssp += this.ifNaN(a.seasons[j].sales_per);
        sao += this.ifNaN(a.seasons[j].actual_order);
        sot += this.ifNaN(a.seasons[j].order_target);
        // s.sales_per = this.calcSP(OT, s.actual_order);
      }
      a.aw_st = sst;
      a.aw_ao = sao;
      a.aw_sp = ssp;
      a.aw_ot = sot;
      a.awd_st = this.ifNaN(a.sales_target - sst);
      a.awd_ot = this.ifNaN(a.order_target - sot);
    }

    data.aw_st = st;
    data.aw_ot = ot;
    data.aw_sp = sp;
    console.log(data);
  }

  process() {
    SalesPlan.doCalc(this.data);
  }

  displayFn(val) {
    if (val && val.fin_id) {
      this.data.fin_id = val.fin_id;
      this.data.finyear = val.finyear;
      this.loadData();
      return val.finyear;
    }
    return "";
  }
  onSaveSalesPlan(): void {
    let that = this;
    let params = {
      data: JSON.stringify(that.data),
    };

    this.isLoading = true;
    this.salesplanService
      .onSaveSalesPlan(params)
      .then(function (res: any) {
        that.isLoading = false;
        if (res.success) {
          //   that.bsModalRef.hide();
          //    that.partyUpdateEvent.emit();
          that.toasterService.pop({
            bodyOutputType: 1,
            type: "success",
            title: "DONE",
            body: "Changes has been saved!",
          });
        } else {
          swal("ERROR", res.message, "error");
        }
      })
      .catch(function (error: any) {
        that.isLoading = false;
        let res = JSON.parse(error._body);
        swal("ERROR", res.message, "error");
        //console.log(error);
      });
  }

  onTest() {
    console.log(this.data);
  }

  LoadFinYearList() {
    let that = this;
    this.finyearService.getFinYearList({}).then((res: any) => {
      that.finyearList = res.data;
      //   that.data.fin_id = res.data[0].fin_id;
      // that.data.finyear = res.data[0].finyear;
      that.finyearCtrl.setValue(res.data[0]);
      that.loadData();
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/salesplanreport/salesplanreport.component.ts